import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "../components/loader";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup";

let { lambda, appname } = window.app;

const UpgradePage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { search } = state || {};

  const [user, setUser] = useState("");
  const [activeButtons, setActiveButtons] = useState({});
  const [perpage, setPerpage] = useState(10);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [image, setImg] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [subscriptionsData, setSubscriptionsData] = useState([]);

  const [flag, setFlag] = useState(false);
  const [firstTime, setFirstTime] = useState(false);
  const [activePlan, setActivePlan] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  let id = localStorage.getItem("userId");
  const { searchedFlag, setSearchedFlag, clientInfo, isLoading, setIsLoading, isRefreshed, setIsRefreshed, userData, subscriberData, setSubscriberData, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "User Management")
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard

  const prevRoute = usePrevious(route)
  useEffect(() => {
    if (prevRoute !== undefined && prevRoute != route) {
      setCurrentPage(1)
      setRowsPerPage(15)
      setSearchedFlag(false);
      setUserSearch("")
    }
  }, [prevRoute]);

  console.log("clientInfoooooooooooooooooooooooooooooooooooooooooo", clientInfo)
  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);

  console.log("clientInfoooooooooooooooooooooooooooooooooooo", clientInfo)
  useEffect(() => {

    if (clientInfo?.planid) {
      getSubscriptionsApi();
    }
    setActiveMenuId()
  }, [clientInfo?.planid]); // <-- run when planid is available

  //   useEffect(() => {
  //     if (!localStorage.getItem("token")) {
  //         navigate("/signin");
  //     }

  // }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    // Skip if clientInfo is still empty
    if (!clientInfo?.subscriptionPayment) return;

    if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
      navigate("/signin");
    }
  }, [clientInfo, navigate]);

  const getSubscriptionsApi = async () => {
    setIsLoading(true);

    try {
      const response = await axios.get(`${lambda}/getSubscriptions?appname=${appname}`);
      const data = response?.data?.result;

      if (data && data !== "Invalid token or Expired") {
        setSubscriptionsData(data);

        // Set default active buttons for each plan
        const defaultButtons = {};
        data.forEach(plan => {
          defaultButtons[plan.planid] = ['Monthly', 'Yearly'];
        });
        setActiveButtons(defaultButtons);

        // Determine selected plan based on clientInfo.planid and plantype
        let selectedPlanData = data.find(plan =>
          (clientInfo.plantype === "Monthly" && plan.monthly_planid === clientInfo.planid) ||
          (clientInfo.plantype === "Yearly" && plan.yearly_planid === clientInfo.planid)
        );

        if (selectedPlanData) {
          setSelectedPlan({
            ...selectedPlanData,
            planType: clientInfo.plantype
          });
        } else {
          // fallback if match not found
          setSelectedPlan({
            ...data[0],
            planType: "Monthly"
          });
        }

        // Set active plan toggle for current plan
        const btn = {};
        data.forEach(plan => {
          if (plan.monthly_planid === clientInfo.planid) {
            btn[plan.planid] = "Monthly";
          } else if (plan.yearly_planid === clientInfo.planid) {
            btn[plan.planid] = "Yearly";
          } else {
            btn[plan.planid] = "Monthly"; // default
          }
        });
        setActivePlan(btn);
      } else {
        setShowSessionPopupup(true);
      }
    } catch (err) {
      console.error('Error fetching subscriptions:', err);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (activeButtons && clientInfo) {
      const btn = {};
      for (const key in activeButtons) {
        const monthlyIdMatch = subscriptionsData.find(p => p.monthly_planid === clientInfo.planid);
        const yearlyIdMatch = subscriptionsData.find(p => p.yearly_planid === clientInfo.planid);
        if (monthlyIdMatch && key == monthlyIdMatch.planid) {
          btn[key] = "Monthly";
        } else if (yearlyIdMatch && key == yearlyIdMatch.planid) {
          btn[key] = "Yearly";
        } else {
          btn[key] = "Monthly"; // default
        }
      }
      setActivePlan(btn);
    }
  }, [activeButtons, clientInfo, subscriptionsData]);



  const handlePlanClick = (planId, type) => {
    setActivePlan(prev => ({
      ...prev,
      [planId]: type
    }));

    if (selectedPlan?.planid === planId) {
      setSelectedPlan(prevPlan => ({
        ...prevPlan,
        planType: type
      }));
    }
    setFirstTime(true);
  };


  const handleSelectPlan = (plan) => {
    const updatedSelectedPlan = {
      ...plan,
      planType: activePlan[plan.planid] || 'Monthly'
    };
    setSelectedPlan(updatedSelectedPlan);
    setFirstTime(true);
  };
  console.log("FirstTimeeeeeeeeeeeeeeeeeeeee", firstTime)
  const handleUpgrade = () => {
    const formData = { ...subscriberData };
    formData.subscription = selectedPlan?.planname;
    formData.subscriptionPrice = selectedPlan?.planType === "Monthly" ? selectedPlan?.monthly : selectedPlan?.yearly;
    formData.plantype = selectedPlan?.planType;
    formData.planid = selectedPlan?.planType == "Monthly" ? selectedPlan?.monthly_planid : selectedPlan?.yearly_planid;
    localStorage.setItem("billingAddress", null)
    navigate("/payment", { state: formData });
  };
  const planRanks = {};
  subscriptionsData.forEach((plan, index) => {
    planRanks[plan.planname] = index + 1;
  });

  const isSubscriptionExpired = clientInfo?.subscriptionEndDate
    ? moment(clientInfo.subscriptionEndDate).isBefore(moment())
    : false;

  // clientInfo.planid holds the Stripe price id, so it has to be compared with the
  // plan id resolved for the selected billing cycle - never with plan.planid.
  const selectedBillingPlanId = selectedPlan?.planType === "Monthly" ? selectedPlan?.monthly_planid : selectedPlan?.yearly_planid;
  const selectedPlanPrice = selectedPlan?.planType === "Monthly" ? selectedPlan?.monthly : selectedPlan?.yearly;
  const isCurrentSubscription = selectedBillingPlanId === clientInfo?.planid && selectedPlan?.planType === clientInfo?.plantype;
  // Same plan at the same price is not an upgrade either - a free plan is $0 on both
  // Monthly and Yearly, so switching the cycle leaves nothing to pay for.
  const isSamePricedPlan = selectedPlan?.planname === clientInfo?.subscription
    && Number(selectedPlanPrice) === Number(clientInfo?.subscriptionPrice);
  const isPlanChange = !!selectedPlan && !isCurrentSubscription && !isSamePricedPlan;

  return (
    <>
      {showSessionPopupup && <SessionPopup />}

      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        {isLoading ? <Loader /> :
          <div className="main-content user-management" id="main-upgrade">
            <div className="page-content" id="page-upgrade">
              <div className="container-fluid" id="container-upgrade">
                <div className="row breadcrumb" id="breadcrumb-upgrade">
                  <div className="col-lg-12" id="col-lg-upgrade">
                    <div className="d-flex align-items-center" id="items-upgrade">
                      <div className="flex-grow-1">
                        <h4 className="mb-2 card-title">Upgrade</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row table-data">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="subscription-plan">

                          <p className="card-desc mb-1">Upgrade to get more out of subscription</p>
                          {clientInfo?.subscriptionEndDate && (
                            clientInfo?.subscriptionPayment === "PAYMENT FAILED" ? (
                              <p className="text-danger mb-4">
                                Your last payment failed. Your subscription ended on{" "}
                                <strong>{moment(clientInfo.subscriptionEndDate).format('MMM DD, YYYY')}</strong>. Please update your payment method to continue.
                              </p>
                            ) : clientInfo?.subscriptionPayment === "PAYMENT SUCCESS" ? (
                              isSubscriptionExpired ? (
                                <p className="text-danger mb-4">
                                  Your subscription expired on{" "}
                                  <strong>{moment(clientInfo.subscriptionEndDate).format('MMM DD, YYYY')}</strong>. Please renew to continue enjoying the benefits.
                                </p>
                              ) : (
                                <p className="text-muted mb-4">
                                  Your subscription is valid until{" "}
                                  <strong>{moment(clientInfo.subscriptionEndDate).format('MMM DD, YYYY')}</strong>
                                </p>
                              )
                            ) : null
                          )}
                          <div className="row registration">
                            {activePlan && subscriptionsData && clientInfo && subscriptionsData.filter(p => p.status === 'ACTIVE').map(plan => {
                              // Get selected type for this plan card
                              const selectedType = activePlan[plan.planid] || 'Monthly';

                              // Get dynamic plan IDs based on selectedType and selectedPlan
                              const currentPlanId = selectedType === "Monthly" ? plan.monthly_planid : plan.yearly_planid;
                              const selectedPlanId = selectedPlan?.planType === "Monthly" ? selectedPlan?.monthly_planid : selectedPlan?.yearly_planid;

                              // Determine if this card is selected
                              const isSelected = selectedPlanId === currentPlanId;

                              const planPrice = selectedType === 'Yearly' ? plan.yearly : plan.monthly;

                              // Check if this plan is the current one subscribed by client. A free
                              // plan costs the same on both cycles, so either billing toggle still
                              // points at the plan they already have.
                              const isCurrent = (selectedType === clientInfo.plantype && currentPlanId === clientInfo.planid)
                                || (plan.planname === clientInfo.subscription && Number(planPrice) === Number(clientInfo.subscriptionPrice));
                              const currentPlanRank = planRanks[clientInfo?.subscription];
                              const thisPlanRank = planRanks[plan.planname];

                              return (
                                <div key={plan.planid} className="col-md-3 plans" id={plan.planid}>
                                  <div className={`basic_plan ${isSelected ? 'active_plan' : ''}`} id={`plan-${plan.planid}`}>
                                    <h6>{plan.planname}</h6>
                                    <p className="per_month">
                                      <span>${planPrice}</span> /per {selectedType.toLowerCase()}
                                    </p>
                                    <p>{plan.tagline}</p>

                                    <div className="select_billing mb-3">
                                      {activeButtons[plan.planid]?.map((planType, index) => (
                                        <button
                                          key={planType}
                                          type="button"
                                          id={`btn-${index}`}
                                          className={`yearly ${(activePlan[plan.planid] === planType) ? 'active' : ''}`}
                                          onClick={() => handlePlanClick(plan.planid, planType)}
                                        >
                                          {planType}
                                        </button>
                                      ))}
                                    </div>

                                    <hr />

                                    {plan.features.map((feature, index) => (
                                      feature.value && (
                                        <div key={`${plan.planid}-${index}`} className="points">
                                          <span className="material-symbols-outlined check-icons">chevron_right</span>
                                          <p>{feature.label ? `${feature.value} ${feature.feature}${feature.value > 1 ? 's' : ''}` : feature.value}</p>
                                        </div>
                                      )
                                    ))}

                                    <div className="Plan-select-footer">
                                      <button
                                        type="button"
                                      //  disabled={thisPlanRank < currentPlanRank}
                                        className={`fill-btn ${isSelected ? "" : "black_btn"}`}
                                        onClick={() => {
                                        //  if (!isCurrent)
                                        handleSelectPlan(plan);
                                        }}
                                        id={`button-${plan.planid}`}
                                      >
                                        {isCurrent ? "Current Plan" : isSelected ? "Selected" : "Select"}
                                      </button>

                                    </div>
                                  </div>
                                </div>
                              );
                            })}


                            {firstTime && isPlanChange && (
                              <div className="col-md-3">
                                <div className="final-plan subscription-wrapper">
                                  <div className="d-flex sub-header">
                                    <h3 className="description mt-1">Upgrade to</h3>
                                  </div>
                                  <h3 className="premium-heading">{selectedPlan.planname}</h3>
                                  <h3 className="card-title">
                                    ${selectedPlan.planType === "Monthly" ? selectedPlan.monthly : selectedPlan.yearly}
                                    <span className="title-s"> /{selectedPlan.planType}</span>
                                  </h3>
                                  <div className="sub-section dashed mt-5">
                                    <div className="d-flex justify-content-between">
                                      <p className="description">Amount Payable</p>
                                      <p className="description">${selectedPlan.planType === "Monthly" ? selectedPlan.monthly : selectedPlan.yearly}</p>
                                    </div>
                                    <button className="basic-btn active w-100 mt-3" id="upgrade-now" onClick={handleUpgrade}>
                                      Upgrade Now
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <SweetAlert
              show={tableErrMsg}
              custom
              confirmBtnText="ok"
              confirmBtnBsStyle="primary"
              title={"Something went wrong. Please reload again."}
              onConfirm={() => setTableErrMsg(false)}
            />

            <Footer />
          </div>
        }
      </div>

    </>
  );
};

export default UpgradePage;